// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from "react";
import ItemElement from "./item-element";
import ExpandableCategoryElement from "./category-elements/expandable-category-element";
import CategoryElement from "./category-elements/category-element";
import { isItemGroup } from "./utils/utils";
import { useMobile } from "../internal/hooks/use-mobile";
import MobileExpandableCategoryElement from "./category-elements/mobile-expandable-category-element";
export default function ItemsList(_a) {
    var items = _a.items, onItemActivate = _a.onItemActivate, onGroupToggle = _a.onGroupToggle, targetItem = _a.targetItem, isHighlighted = _a.isHighlighted, isKeyboardHighlight = _a.isKeyboardHighlight, isExpanded = _a.isExpanded, highlightItem = _a.highlightItem, _b = _a.categoryDisabled, categoryDisabled = _b === void 0 ? false : _b, _c = _a.hasExpandableGroups, hasExpandableGroups = _c === void 0 ? false : _c, _d = _a.hasCategoryHeader, hasCategoryHeader = _d === void 0 ? false : _d, _e = _a.expandToViewport, expandToViewport = _e === void 0 ? false : _e, _f = _a.variant, variant = _f === void 0 ? "normal" : _f;
    var isMobile = useMobile();
    var elements = items.map(function(item, index) {
        var _a, _b, _c, _d;
        if (!isItemGroup(item)) {
            return /*#__PURE__*/ React.createElement(ItemElement, {
                key: index,
                item: item,
                onItemActivate: onItemActivate,
                disabled: (_a = item.disabled) !== null && _a !== void 0 ? _a : categoryDisabled,
                highlighted: isHighlighted(item),
                isKeyboardHighlighted: isKeyboardHighlight(item),
                highlightItem: highlightItem,
                first: index === 0 || isItemGroup(items[index - 1]),
                last: index === items.length - 1 || isItemGroup(items[index + 1]),
                hasCategoryHeader: hasCategoryHeader,
                variant: variant
            });
        }
        if (hasExpandableGroups) {
            return item.text ? isMobile ? /*#__PURE__*/ React.createElement(MobileExpandableCategoryElement, {
                key: index,
                item: item,
                onItemActivate: onItemActivate,
                onGroupToggle: onGroupToggle,
                targetItem: targetItem,
                isHighlighted: isHighlighted,
                isKeyboardHighlight: isKeyboardHighlight,
                isExpanded: isExpanded,
                highlightItem: highlightItem,
                disabled: (_b = item.disabled) !== null && _b !== void 0 ? _b : false,
                variant: variant
            }) : /*#__PURE__*/ React.createElement(ExpandableCategoryElement, {
                key: index,
                item: item,
                onItemActivate: onItemActivate,
                onGroupToggle: onGroupToggle,
                targetItem: targetItem,
                isHighlighted: isHighlighted,
                isKeyboardHighlight: isKeyboardHighlight,
                isExpanded: isExpanded,
                highlightItem: highlightItem,
                disabled: (_c = item.disabled) !== null && _c !== void 0 ? _c : false,
                expandToViewport: expandToViewport,
                variant: variant
            }) : null;
        }
        return /*#__PURE__*/ React.createElement(CategoryElement, {
            key: index,
            item: item,
            onItemActivate: onItemActivate,
            onGroupToggle: onGroupToggle,
            targetItem: targetItem,
            isHighlighted: isHighlighted,
            isKeyboardHighlight: isKeyboardHighlight,
            isExpanded: isExpanded,
            highlightItem: highlightItem,
            disabled: (_d = item.disabled) !== null && _d !== void 0 ? _d : false,
            variant: variant
        });
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, elements);
} //# sourceMappingURL=items-list.js.map
